import { Grid, Container } from "@mui/material";
import ButtonNav from "../components/General/ButtonNav";
import { useAuth } from "../context/AuthContext";

import FolderOpenRoundedIcon from "@mui/icons-material/FolderOpenRounded";
import InsertDriveFileRoundedIcon from "@mui/icons-material/InsertDriveFileRounded";
import SummarizeRoundedIcon from "@mui/icons-material/SummarizeRounded";

export default function Liquidations() {
  const { hasPermission } = useAuth();

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {(hasPermission("ver liquidaciones") || hasPermission("ver liquidaciones comunes")) && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Ver Liquidaciones"
              subtitle="Municipalidad y comunes en una sola grilla, con su tipo"
              icon={<FolderOpenRoundedIcon />}
              color="#7c3aed"
              to={hasPermission("ver liquidaciones") ? "/liquidations/manager" : "/individual-liquidations/manager"}
            />
          </Grid>
        )}

        {hasPermission("exportar reporte liquidaciones comunes") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Planilla Liquidaciones Comunes"
              subtitle="Desglose de rubros, intereses y punitorios por expediente común"
              icon={<SummarizeRoundedIcon />}
              color="#1d4ed8"
              to="/individual-liquidations/report"
            />
          </Grid>
        )}

        {hasPermission("exportar reporte sentencia") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Planilla Municipalidad"
              subtitle="Expedientes con sentencia y honorarios de sentencia/ejecución"
              icon={<InsertDriveFileRoundedIcon />}
              color="#9d174d"
              to="/liquidations/municipality-report"
            />
          </Grid>
        )}

        {hasPermission("exportar reporte liquidaciones") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Planilla de Liquidaciones"
              subtitle="Desglose completo de rubros y totales por expediente liquidado"
              icon={<SummarizeRoundedIcon />}
              color="#0f766e"
              to="/liquidations/liquidation-report"
            />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
